import type { ColorPalette, PaletteKey } from './types';

export const BRAVEMOVE_PALETTES: Readonly<Record<PaletteKey, ColorPalette>> = {
  garnet_light: {
    bg: '#F7F2EE',
    surface: '#FFFFFF',
    surface2: '#EEE6DF',
    panel: '#1B0D14',
    panelInk: '#F6EAEE',
    ink: '#1B0D14',
    ink2: '#4A3641',
    ink3: '#73606B',
    muted: '#B8A5AE',
    hairline: 'rgba(27,13,20,0.08)',
    hairline2: 'rgba(27,13,20,0.16)',
    accent: '#A6184D',
    accent2: '#7A0F38',
    accentInk: '#FFFFFF',
    accentSoft: 'rgba(166,24,77,0.1)',
    primary: '#A6184D',
    primaryHover: '#7A0F38',
    primaryInk: '#FFFFFF',
    accentText: '#A6184D',
    secondary: '#C46B3A',
    tertiary: '#C19A2A',
    success: '#2C7A4A',
    warning: '#C19A2A',
    danger: '#A6184D',
    dangerInk: '#FFFFFF',
    info: '#2A5DA8',
  },
  garnet_dark: {
    bg: '#14080E',
    surface: '#1E1118',
    surface2: '#2A1822',
    panel: '#0A0408',
    panelInk: '#F6EAEE',
    ink: '#F6EAEE',
    ink2: '#C2A8B2',
    ink3: '#A18490',
    muted: '#5C4750',
    hairline: 'rgba(246,234,238,0.08)',
    hairline2: 'rgba(246,234,238,0.16)',
    accent: '#E04579',
    accent2: '#C42857',
    accentInk: '#14080E',
    accentSoft: 'rgba(224,69,121,0.18)',
    primary: '#E04579',
    primaryHover: '#F174A0',
    primaryInk: '#14080E',
    accentText: '#F174A0',
    secondary: '#EFA379',
    tertiary: '#E8C160',
    success: '#34D08A',
    warning: '#E8C160',
    danger: '#FF6B6B',
    dangerInk: '#14080E',
    info: '#7DA3FF',
  },
  slate_light: {
    bg: '#F4F5F8',
    surface: '#FFFFFF',
    surface2: '#E8ECF0',
    panel: '#0C1228',
    panelInk: '#EEF1FA',
    ink: '#0C1228',
    ink2: '#2E3854',
    ink3: '#606983',
    muted: '#A5ACBE',
    hairline: 'rgba(12,18,40,0.08)',
    hairline2: 'rgba(12,18,40,0.16)',
    accent: '#1A3B8A',
    accent2: '#0F2862',
    accentInk: '#FFFFFF',
    accentSoft: 'rgba(26,59,138,0.1)',
    primary: '#1A3B8A',
    primaryHover: '#0F2862',
    primaryInk: '#FFFFFF',
    accentText: '#1A3B8A',
    secondary: '#0E7A8A',
    tertiary: '#A6184D',
    success: '#0E7A4D',
    warning: '#C68A1F',
    danger: '#A6184D',
    dangerInk: '#FFFFFF',
    info: '#1A3B8A',
  },
  slate_dark: {
    bg: '#06112E',
    surface: '#0E1C42',
    surface2: '#15275A',
    panel: '#040A1F',
    panelInk: '#EEF1FA',
    ink: '#EEF1FA',
    ink2: '#A4ACC8',
    ink3: '#8993B2',
    muted: '#4A5570',
    hairline: 'rgba(238,241,250,0.08)',
    hairline2: 'rgba(238,241,250,0.16)',
    accent: '#3F6DE0',
    accent2: '#2853BB',
    accentInk: '#06112E',
    accentSoft: 'rgba(63,109,224,0.18)',
    primary: '#6B94FF',
    primaryHover: '#90AFFF',
    primaryInk: '#06112E',
    accentText: '#90AFFF',
    secondary: '#1FA8C2',
    tertiary: '#E04579',
    success: '#34D08A',
    warning: '#E8C160',
    danger: '#FF6B6B',
    dangerInk: '#06112E',
    info: '#7DA3FF',
  },
};

export const PALETTE_KEYS: readonly PaletteKey[] = [
  'garnet_light',
  'garnet_dark',
  'slate_light',
  'slate_dark',
];
